import { useEffect, useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { getSessionSubject, Session } from '../../../Api/useSession';
import { getSelectedAccountsSubject } from '../../../store/User';

export const ProtectedRoute = () => {
  const [session, setSession] = useState<Session | undefined>(() => getSessionSubject().getValue?.());
  const navigate = useNavigate();
  const location = useLocation();

  // Subscribe to user data and error states.
  useEffect(() => {
    const dataSubscription = getSessionSubject().subscribe((data) => {
      setSession(data);
    });

    return () => {
      if (dataSubscription) dataSubscription.unsubscribe();
    };
  }, []);

  useEffect(() => {
    const userAccountsSub = getSelectedAccountsSubject().subscribe((accounts) => {
      if (!accounts?.length && ['/orders', '/support-cases', '/inventory', '/projects'].includes(location.pathname)) {
        navigate('/');
      }
    });

    return () => {
      if (userAccountsSub) userAccountsSub?.unsubscribe();
    };
  }, [location.pathname]);

  useEffect(() => {
    if (session !== undefined && !session?.authenticated) navigate('/login');
  }, [session?.authenticated]);

  return <Outlet />;
};
